/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_No_One_HereInputs */

const en_admin_dashboard_no_one_here = /** @type {(inputs: Admin_Dashboard_No_One_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No one here`)
};

const de_admin_dashboard_no_one_here = /** @type {(inputs: Admin_Dashboard_No_One_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niemand hier`)
};

const es_admin_dashboard_no_one_here = /** @type {(inputs: Admin_Dashboard_No_One_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay nadie aquí`)
};

const fr_admin_dashboard_no_one_here = /** @type {(inputs: Admin_Dashboard_No_One_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personne ici`)
};

const nl_admin_dashboard_no_one_here = /** @type {(inputs: Admin_Dashboard_No_One_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niemand aanwezig`)
};

const it_admin_dashboard_no_one_here = /** @type {(inputs: Admin_Dashboard_No_One_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno qui`)
};

const pt_br2_admin_dashboard_no_one_here = /** @type {(inputs: Admin_Dashboard_No_One_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguém aqui`)
};

const pl_admin_dashboard_no_one_here = /** @type {(inputs: Admin_Dashboard_No_One_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nikogo tu nie ma`)
};

const hu_admin_dashboard_no_one_here = /** @type {(inputs: Admin_Dashboard_No_One_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senki sincs itt`)
};

const ro_admin_dashboard_no_one_here = /** @type {(inputs: Admin_Dashboard_No_One_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nimeni aici`)
};

/**
* | output |
* | --- |
* | "No one here" |
*
* @param {Admin_Dashboard_No_One_HereInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_no_one_here = /** @type {((inputs?: Admin_Dashboard_No_One_HereInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_No_One_HereInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_no_one_here(inputs)
	if (locale === "de") return de_admin_dashboard_no_one_here(inputs)
	if (locale === "es") return es_admin_dashboard_no_one_here(inputs)
	if (locale === "fr") return fr_admin_dashboard_no_one_here(inputs)
	if (locale === "nl") return nl_admin_dashboard_no_one_here(inputs)
	if (locale === "it") return it_admin_dashboard_no_one_here(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_no_one_here(inputs)
	if (locale === "pl") return pl_admin_dashboard_no_one_here(inputs)
	if (locale === "hu") return hu_admin_dashboard_no_one_here(inputs)
	return ro_admin_dashboard_no_one_here(inputs)
});
export { admin_dashboard_no_one_here as "admin.dashboard.no_one_here" }